import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';


// Solo el 401 (token inválido/expirado) cierra la sesión. El 403 es un permiso
// denegado puntual: se muestra el mensaje pero NO se desloguea al usuario.
const unauthorizedCode = [401]

// Timeout generoso: generar un cupón implica PDF (Puppeteer) + Timely + S3 y
// puede superar los 4s; con un timeout corto axios aborta, el backend igual
// termina (cupón creado + email) y el usuario no ve feedback.
const service = axios.create({
	baseURL: API_BASE_URL,
	timeout: 60000
})

// Config
const TOKEN_PAYLOAD_KEY = 'Authorization'

// API Request interceptor
service.interceptors.request.use(config => {
	const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

	if (jwtToken) {
		config.headers[TOKEN_PAYLOAD_KEY] = "Bearer " + jwtToken
	}

	return config
}, error => {
	// Do something with request error here
	notification.error({
		message: 'Error'
	})
	Promise.reject(error)
})

// API respone interceptor
service.interceptors.response.use((response) => {

	return response.data
}, (error) => {

	let notificationParam = {
		message: ''
	}

	// Timeout o error de red: no hay response. Sin este guard, leer
	// error.response.status tira TypeError y el usuario no ve ningún aviso.
	if (!error.response) {
		notificationParam.message = 'No se pudo contactar al servidor'
		notificationParam.description = 'Revisá tu conexión y volvé a intentar. Si estabas generando un cupón, verificá en el listado si ya se creó antes de reintentar.'
		notification.error(notificationParam)
		return Promise.reject(error);
	}

	// Remove token and redirect
	if (unauthorizedCode.includes(error.response.status)) {
		notificationParam.message = error.response.data.message
		notificationParam.description = 'Please login again'
		localStorage.removeItem(AUTH_TOKEN)

		store.dispatch(signOutSuccess())
	}

	// 403: permiso denegado — mostrar el mensaje sin cerrar la sesión.
	if (error.response.status === 403) {
		notificationParam.message = error.response.data.message
	}

	if (error.response.status === 400 || error.response.status === 409) {
		notificationParam.message = error.response.data.message
	}

	if (error.response.status === 404) {
		notificationParam.message = error.response.data.message
	}

	if (error.response.status === 500) {
		notificationParam.message = 'Internal Server Error'
	}

	if (error.response.status === 508) {
		notificationParam.message = 'Time Out'
	}

	notification.error(notificationParam)

	return Promise.reject(error);
});

export default service